import experienceShop from './experienceShop'
import customerManage from './customerManage'
import incomeManage from './incomeManage'
import orderManage from './orderManage'
import appraiseManage from './appraiseManage'
import notificationManage from './notificationManage'

export default [
  ...experienceShop,
  customerManage,
  incomeManage,
  orderManage,
  ...appraiseManage,
  notificationManage
]
